import { Box, Card, Image, SimpleGrid, Text, Autocomplete, Space, Paper, LoadingOverlay } from "@mantine/core";
import React, { memo, useContext, useEffect, useState } from "react";
import classes from "./VerticalsLca.module.css";
import { FaChevronRight } from "react-icons/fa6";
import useFetch from "../../../../Customhooks/useFetch";
import { baseUrl } from "../../../../Constants/constant"; 
import { IoMdSearch } from "react-icons/io";
import { authContext } from "../../../../context/AuthProvider.component";

const VerticalsLca = ({ setid }: any) => {
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');
  const [selectedVerticalId, setSelectedVerticalId] = useState<any>();
  const token = localStorage.getItem("token");
  const updatedUrl = baseUrl.replace("/api/", "");
  const { setComputeId, setError } = useContext<any>(authContext);

  const {
    data: getfieldData,
    loading: getfieldLoading,
    error: getfieldError,
    fetchData: getfield,
  } = useFetch({
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: token || "",
    },
  });

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    if (getfieldError) {
      setError(getfieldError?.message)
    }
  }, [getfieldError]);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  useEffect(() => {
    getfield(`${baseUrl}admin/verticals?search=${sendsearch || ''}`);
  }, [sendsearch]);

  // if (getfieldLoading) {
  //   return (
  //     <Center style={{ height: "100vh" }}>
  //       <Loader />
  //     </Center>
  //   );
  // }

  const handleClick = (id: any) => {
    setid(id);
    setComputeId(null);
    const storedId = sessionStorage.getItem('selectedVerticalId');
    if (storedId) {
      setSelectedVerticalId(JSON.parse(storedId));
    } else {
      setSelectedVerticalId(undefined);
    }
  };


  return (
    <div>
                  <LoadingOverlay
                      visible={getfieldLoading}
                      zIndex={1000}
                      overlayProps={{
                          radius: 'sm',
                          blur: 2,
                          style: {
                              position: 'fixed',
                              top: 0,
                              left: 0,
                              width: '100%',
                              height: '100%'
                          }
                      }}
                      loaderProps={{ color: '#404040', type: 'bars' }}
                  />
      <Paper p={20} style={{ border: '1px solid #00000026' }}>
        <Box display={'flex'} style={{ justifyContent: 'space-between' }}>
          <Text fw={600}>Select Category</Text>
          <Autocomplete
            value={search}
            onChange={handlechange}
            placeholder="Search by Category"
            leftSection={<IoMdSearch />}
          />
        </Box>
        <Space h="lg" />
        <SimpleGrid cols={{ base: 1, sm: 1, lg: 3 }}>
          {getfieldData?.data?.rows?.map((el: any, index: number) => (
            <Card
              shadow="xs"
              padding="lg"
              className={classes.card}
              key={index}
              onClick={() => handleClick(el.vertical_id)}
              style={{
                border: selectedVerticalId === el.vertical_id ? '2px solid #404040' : '2px solid #fff',
                transition: 'border 0.2s ease'
              }}
            >
              <Box style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                <Box className={classes.verticalslogo}>
                  <Image fit="contain" src={`${updatedUrl}${el.icon_name}`} alt="icon" />
                </Box>
                <Text fw={400} size="lg">
                  {el.vertical_name}
                </Text>
              </Box>
              <Box pt={4}>
                <FaChevronRight />
              </Box>
            </Card>
          ))}
        </SimpleGrid>
      </Paper>
    </div>
  );
};

export default memo(VerticalsLca);